module.exports = __webpack_public_path__ + "img/logo-on-white.a5680a3f.svg";